<template>
    <el-dialog 
      title="价格定义" 
      :visible.sync="dialogDefinitionVisible" 
      width="1200px" top="10vh" 
      append-to-body 
      :before-close="close">
        <el-form ref="priceDefinition" :model="priceDefinition" size="small">
            <el-row class="price-row clearfix" :gutter="10">
                <!--左侧主类目 变量+主费用+附加费用-->
                <el-col :span="4" class="leftCol">
                    <ul class="left-wrapper list-group">
                        <li class="list-group-item" :class="['basic', isBasicActive? 'active' : '']" @click="toggleActiveTab('basic', '')">
                            <el-button size="small" class="list-content">基础信息</el-button>
                            <div class="sub-left-wrapper">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        <label>货币单位：</label>{{priceDefinition.currency}}</li>
                                    <li class="list-group-item valid-item clearfix">
                                        <label>价格有效期</label>
                                        <div>从&nbsp;
                                            <span>{{priceDefinition.effectiveFrom}}</span>
                                        </div>
                                        <div>至&nbsp;
                                            <span>{{priceDefinition.effectiveTo}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="list-group-item" :class="['custom', isCustomActive? 'active' : '']">
                          <el-button size="small" class="list-content" @click="toggleActiveTab('custom', '')">自定义变量</el-button>
                          <div class="sub-left-wrapper">
                              <ul class="list-group">
                                  <li class="list-group-item" v-for="(variable, index) in priceDefinition.userDefinedVariables" :key="index">
                                      <a href="#" class="sub-list-item" @click.prevent="toggleActiveTab('custom', variable)">{{variable.name}}</a>
                                      <i class="el-icon-delete" @click.prevent="deleteVariable(index)" title="删除"></i>
                                  </li>
                              </ul>
                          </div>
                        </li>
                        <li class="list-group-item" :class="['main', isMainActive? 'active' : '']">
                            <el-button size="small" class="list-content" @click.prevent="toggleActiveTab('main', '')">主费用</el-button>
                        </li>

                        <li class="list-group-item" :class="['additionalCharge', isExtraActive? 'active': '']">
                            <el-button size="small" class="list-content" @click.prevent="toggleActiveTab('additionalCharge', '')">附加费用</el-button>
                            <div class="sub-left-wrapper">
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(additionalCharge, index) in priceDefinition.additionalCharges" :key="index">
                                        <a href="#" class="sub-list-item" @click.prevent="toggleActiveTab('additionalCharge', additionalCharge)">{{additionalCharge.name}}</a>
                                        <i class="el-icon-delete" @click.prevent="deleteExtra(index)" title="删除"></i>
                                    </li>
                                </ul>
                            </div>
                        </li>

                    </ul>
                </el-col>

                <!--中间操作-->
                <el-col :span="16" class="middleCol">
                    <div class="middle-wrapper">
                        <!--基础信息-->
                        <el-card v-show="isBasicActive">
                            <div slot="header" class="clearfix">
                                <span>基础信息</span>
                            </div>
                            <el-form-item label="货币" :label-width="formLabelWidth" required>
                                <el-select name="currency" v-model="priceDefinition.currency">
                                  <el-option v-for="currency in currencies" :label="currency.name" :value="currency.value" :key="currency.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="价格有效期" :label-width="formLabelWidth" required>
                                <el-date-picker 
                                  v-model="priceDefinition.effectiveFrom" 
                                  type="datetime" 
                                  placeholder="开始日期" 
                                  value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <span>&nbsp;至&nbsp;</span>
                                <el-date-picker 
                                  v-model="priceDefinition.effectiveTo" 
                                  type="datetime" 
                                  placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                        </el-card>

                        <!--自定义变量-->
                        <el-card v-show="isCustomActive">
                            <div slot="header" class="clearfix">
                                <span>添加自定义变量</span>
                            </div>
                            <el-form-item label="变量名称" :label-width="formLabelWidth">
                                <el-input v-model="newVariable.name" placeholder="英文字母组合的一个文字串"></el-input>
                            </el-form-item>
                            <el-form-item label="计算公式" :label-width="formLabelWidth">
                                <el-input type="textarea" :rows="4" v-model="newVariable.formula" placeholder="JavaScript语法的一个表达式"></el-input>
                            </el-form-item>
                            <el-form-item :label-width="formLabelWidth">
                                <el-button @click="addVariable">确认</el-button>
                                <el-button @click.prevent="resetAddVariable">重置</el-button>
                            </el-form-item>
                        </el-card>

                        <!--主费用-->
                        <el-card v-show="isMainActive">
                            <div slot="header" class="clearfix">
                                <span>主费用</span>
                            </div>
                            <el-form-item>
                                <ul class="nav nav-pills clear">
                                    <li role="presentation" :class="['MainCal', isMainCalActive? 'active' : '']">
                                        <a href="#" @click.prevent="toggleActiveTab('MainCal')">计算公式</a>
                                    </li>
                                    <li style="margin-left: 6px;" role="presentation" :class="['MainShip', isMainShipActive? 'active' : '']">
                                        <a href="#" @click.prevent="toggleActiveTab('MainShip')">物流价格定义</a>
                                    </li>
                                </ul>
                            </el-form-item>
                            <!-- <el-form-item v-if="priceDefinition.mainCharge.cal === '' || priceDefinition.mainCharge.cal === 'JS'"> -->
                            <el-form-item v-if="isMainActive && isMainCalActive">
                              <!--计算公式-->
                              <div>
                                <h6>销售价：</h6>
                                <el-input type="textarea" :rows="3" v-model.lazy="priceDefinition.mainCharge.formula" placeholder="JavaScript语法的一个表达式，也可以引用基本变量和自定义变量"></el-input>
                              </div>
                              <div>
                                <h6>成本价：</h6>
                                <el-input type="textarea" :rows="3" v-model.lazy="priceDefinition.costCharge.formula" placeholder="JavaScript语法的一个表达式，也可以引用基本变量和自定义变量"></el-input>
                              </div>
                            </el-form-item>
                            <div v-else>
                                <!--物流价格定义-->
                                <el-form-item>
                                    <a href="/static/template/price/Price definition.xlsx" class="download-icon">下载价格及区域模板</a>
                                    <!-- <a href="/static/template/price/Old System Price definition.xlsx" class="download-icon">下载旧物流系统价格以及区域导入模板</a> -->
                                    <form class="price-form" @change="parsePriceDefinitionExcel($event)" enctype="multipart/form-data">
                                        <label>上传模板</label>
                                        <el-tooltip effect="dark" content="请下载左侧模板并按要求填写数据，然后点击右侧 选择文件 上传" placement="right-start">
                                          <i class="el-icon-question"></i>
                                        </el-tooltip>
                                        <input 
                                          class="parse-input"
                                          ref="parseForm"
                                          type="file" 
                                          multiple="multiple" 
                                          name="priceDefinitionFile"
                                          accept=".xls,.xlsx" 
                                          @change="getFile($event)" />
                                        <i class="clear-icon el-icon-circle-close-outline" @click="resetPriceForm()"></i>
                                    </form>
                                    <el-button 
                                      class="el-button__export"
                                      v-if="aggregateId !== '' && priceDefinition.mainCharge.logisticPrice.areas && priceDefinition.mainCharge.logisticPrice.areas.length > 0" 
                                      size="mini" 
                                      @click.prevent="exportPriceDefinitionExcel()"
                                    >导出价格</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <ul class="nav nav-pills clear">
                                        <li role="presentation" :class="['area', isAreaActive? 'active' : '']">
                                            <a href="" @click.prevent="toggleActiveTab('area', '')">1、定义分区</a>
                                        </li>
                                        <li role="presentation" :class="['unitWeight', isWeightActive? 'active' : '']">
                                            <a href="#" @click.prevent="toggleActiveTab('unitWeight', '')">2、定义重量段及费用</a>
                                        </li>
                                    </ul>
                                </el-form-item>
                                <!-- 定义分区 -->
                                <div v-show="isAreaActive">
                                    <el-form-item>
                                        <el-button type="text" @click="dialogTableVisible = true">添加分区</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                      <table class="area-table">
                                        <thead>
                                          <tr>
                                            <th>分区编号</th>
                                            <th>分区国家</th>
                                            <th>操作</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(area, index) in priceDefinition.mainCharge.logisticPrice.areas">
                                            <td>
                                              <span v-if="!editing">{{area.areaCode}}</span>
                                              <el-input ref:input v-if="editing" v-model="area.areaCode" @input="updateView($event)" />
                                            </td>
                                            <td>
                                              <span v-if="!editing">{{area.regions.join()}}</span>
                                              <el-input ref:input v-if="editing" v-model="area.regionStr" @input="updateView($event)" />
                                            </td>
                                            <td>
                                              <i class="el-icon-delete" @click="deleteArea(index, area)"></i>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </el-form-item>
                                    <el-form-item v-show="priceDefinition.mainCharge.logisticPrice.areas != null && priceDefinition.mainCharge.logisticPrice.areas.length > 0">
                                        <el-button size="small" type="warning" @click="edit">全部编辑</el-button>
                                        <el-button size="small" type="primary" @click="save">保存</el-button>
                                    </el-form-item>
                                </div>
                                <!-- 重量段及费用 -->
                                <div v-show="isWeightActive">
                                    <el-form-item label="分区编号" :label-width="formLabelWidth">
                                        <el-select 
                                          name="unitWeight" 
                                          v-model="priceDefinition.mainCharge.logisticPrice.selectedAreaCode" 
                                          @change="selectAreaCode"
                                          placeholder = "请选择分区编号">
                                            <el-option 
                                            v-for="(area, index) in priceDefinition.mainCharge.logisticPrice.areas" 
                                            :value="area.areaCode" 
                                            :key="index" 
                                            :label="area.areaCode">
                                            </el-option>
                                        </el-select>
                                        <el-button type="text" @click="addMainCharge">添加费用</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-table :data="priceDefinition.mainCharge.logisticPrice.prices[priceDefinition.mainCharge.logisticPrice.selectedAreaCode]" border >
                                            <el-table-column label="重量从" width="100px">
                                                <template slot-scope="scope">
                                                    <span v-if="!isEditPrice">{{scope.row.from}}</span>
                                                    <el-input ref:input v-if="isEditPrice" v-model="scope.row.from" />
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="重量到" width="100px">
                                                <template slot-scope="scope">
                                                    <span v-if="!isEditPrice">{{scope.row.to}}</span>
                                                    <el-input ref:input v-if="isEditPrice" v-model="scope.row.to" />
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="计费重量单位" width="120px">
                                                <template slot-scope="scope">
                                                    <span v-if="!isEditPrice">{{scope.row.unitWeight}}</span>
                                                    <el-input ref:input v-if="isEditPrice" v-model="scope.row.unitWeight" />
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="费用定义分类" width="250px">
                                                <template slot-scope="scope">
                                                    <span v-if="!isEditPrice && 'COST' === scope.row.chargeType">成本</span>
                                                    <span v-else-if="!isEditPrice && 'CONSTANT' === scope.row.chargeType">固定费用</span>
                                                    <span v-else-if="!isEditPrice && 'UNITPRICE' === scope.row.chargeType">简单单价（重量*单价）</span>
                                                    <span v-else-if="!isEditPrice && 'CHAINED' === scope.row.chargeType">续重单价（除扣前一个重量段剩下的重量 * 单价）</span>
                                                    <el-select name="currency" v-if="isEditPrice" v-model="scope.row.chargeType" style = "width: 100%;" placeholder = "请选择费用定义分类">
                                                      <el-option v-for="(chargeType, index) in chargeTypes" :value="chargeType.value" :label="chargeType.name" :key="index"></el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="重量段费用">
                                                <template slot-scope="scope">
                                                    <span v-if="!isEditPrice">{{scope.row.price}}</span>
                                                    <el-input type="textarea" :rows="2" ref:input v-if="isEditPrice" v-model="scope.row.price" />
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="成本价">
                                                <template slot-scope="scope">
                                                    <span v-if="!isEditPrice">{{scope.row.costPrice}}</span>
                                                    <el-input type="textarea" :rows="2" ref:input v-if="isEditPrice" v-model="scope.row.costPrice" />
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="操作" width="50px">
                                                <template slot-scope="scope">
                                                    <i class="el-icon-delete" @click="deletePrice(scope.$index, scope.row)"></i>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form-item>
                                    <el-form-item v-show="priceDefinition.mainCharge.logisticPrice.prices[this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode] != null
                                                && priceDefinition.mainCharge.logisticPrice.prices[this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode].length > 0">
                                        <el-button size="small" type="warning" @click="editPrice">全部编辑</el-button>
                                        <el-button size="small" type="primary" @click="savePrice(priceDefinition.mainCharge.logisticPrice.prices[priceDefinition.mainCharge.logisticPrice.selectedAreaCode])" v-if = "isEditPrice">保存</el-button>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-card>

                        <!--附加费用-->
                        <el-card v-show="isExtraActive">
                            <div slot="header" class="clearfix">
                                <span>附加费用</span>
                            </div>
                            <el-form-item label="变量名称" :label-width="formLabelWidth" required>
                                <el-input v-model="newExtra.name" placeholder="英文字母组合的一个文字串" />
                            </el-form-item>
                             <el-form-item label="费用名称" :label-width="formLabelWidth" required>
                                <el-input v-model="newExtra.chargeName" placeholder="英文字母组合的一个文字串或者中文" />
                            </el-form-item>
                            <!-- <el-form-item label="条件" :label-width="formLabelWidth">
                                <el-input v-model="newExtra.condition" placeholder="满足收取额外费用的条件" />
                            </el-form-item> -->
                            <el-form-item label="计算公式" :label-width="formLabelWidth" required>
                                <el-input type="textarea" :rows="4" v-model="newExtra.formula" placeholder="JavaScript语法的一个表达式" />
                            </el-form-item>
                            <el-form-item :label-width="formLabelWidth">
                                <el-button size="small" type="primary" @click="addExtra">确认</el-button>
                                <el-button size="small" @click.prevent="resetAddExtra">重置</el-button>
                            </el-form-item>
                        </el-card>
                    </div>
                </el-col>

                <!--右侧说明部分-->
                <el-col :span="4" class="rightCol">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>备注说明</span>
                        </div>
                        <!--基本变量-->
                        <div class="remark-content">
                            <strong>基本变量：</strong>
                            <a href="#" title="点击查看所有基本变量" @click.prevent="showAllBasicVariables(BasicVariables)"><i class="el-icon-zoom-in"></i></a>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(BasicVariable, index) in BasicVariables" :key="index">
                                  <el-tooltip class="item" effect="dark" placement="top">
                                    <div slot="content">
                                      <div>{{BasicVariable.name}}</div>
                                      <div style="margin-top: 10px;">{{BasicVariable.describe}}</div>
                                    </div>
                                    <i class="el-icon-question"></i>
                                  </el-tooltip>
                                  <span class="name">{{BasicVariable.name}}</span>
                                  <span class="desc">{{BasicVariable.describe}}</span>
                                </li>
                            </ul>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <div class="submitRow">
              <div class="form-group">
                <label>价格格式提交前检查</label>
                <el-switch v-model="preCheck" active-color="#409EFE" inactive-color="#BFCBD6">
                </el-switch>
              </div>
              <div class="form-group upload-test">
                <h5 class="upload-test__title">上传模板--试算价格</h5>
                <el-form class="upload-test__form" enctype="multipart/form-data" name="testPriceForm">
                  <el-form-item label="下载模板">
                    <a class="download" href="/static/template/price/FBA-A-sample.xlsx" title="下载模板">
                      <i class="iconfont icon-xiazai"></i>
                    </a>
                  </el-form-item>
                  <el-form-item label="上传模板">
                    <input type="file" accept=".xlsx,.xls" ref="testPriceFile">
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" type="primary" round @click="uploadAndCheckPrice()">开始测试</el-button>
                    <el-button size="small" round @click="resetTestPrice()">重新测试</el-button>
                  </el-form-item>
                </el-form>
               <el-table v-show="priceTestResult && priceTestResult.length > 0" :data="priceTestResult" style="width: 100%">
									<el-table-column label="总费用" prop="amount"></el-table-column>
									<el-table-column label="费用类型" prop="serviceType"></el-table-column>
									<el-table-column label="金额" prop="unitPrice"></el-table-column>
									<el-table-column label="币种" prop="currency"></el-table-column>
									<el-table-column label="明细" prop="trace">
                    <template slot-scope="scope">
                      <p class="trace-item">
                        <a href="#" title="点击查看明细" @click.prevent="showFormulaDetails(scope.row.trace)"><i class="el-icon-zoom-in"></i></a>
                        {{scope.row.trace}}
                      </p>
                    </template>
                  </el-table-column>
								</el-table>
              </div>
            </div>
            <!-- 显示所有基本变量-弹出层 -->
            <el-dialog title="基本变量列表" :visible.sync="dialogShowVariables" append-to-body>
              <el-table :data="BasicVariableDatas" stripe>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="describe" label="描述"></el-table-column>
            </el-table>
            </el-dialog>
            <!--添加国家分区-弹出层-->
            <el-dialog title="添加分区" :visible.sync="dialogTableVisible" append-to-body :before-close="closeNewArea">
                <el-form :model="newArea" size="small">
                  <el-form-item label="分区编号" :label-width="formLabelWidth">
                      <el-input v-model.lazy="newArea.areaCode" placeholder="请输入分区编号，如 “US001”"></el-input>
                  </el-form-item>
                  <el-form-item label="分区国家" :label-width="formLabelWidth">
                      <el-input type="textarea" :rows="4" v-model.lazy="newArea.regionStr" placeholder="请输入分区国家如,“美国，加拿大”"></el-input>
                  </el-form-item>
                </el-form>
                <div class="remarks">
                  <p>示例：</p>
                  <p>1、<b>US</b> 表示全美国，US是国家简码</p>
                  <p>2、<b>US(@[8|9])</b> 8|9是以8或者9开头的邮编，US是国家简码，(),@,[]是必须的</p>
                  <p>3、<b>US(@[07001~07003])</b> 07001~07003是指07001到07003的区间，包含07001,07002,07003，US是国家简码，(),@,[]是必须的</p>
                  <p>4、<b>US(@[60433,85043])</b> 邮编用逗号分隔，US是国家简码，(),@,[]是必须的</p>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeNewArea()">取 消</el-button>
                    <el-button size="small" type="primary" @click="createArea()">确 定</el-button>
                </div>
            </el-dialog>
            <!--添加重量段及费用-弹出层-->
            <el-dialog title="添加重量段及费用" :visible.sync="dialogFromVisible" append-to-body width="800px">
                <el-form :model="newPrice" size="small">
                    <el-form-item label="重量从" :label-width="formLabelWidth">
                        <el-input v-model="newPrice.from" placeholder="如 “0.0”"></el-input>
                    </el-form-item>
                    <el-form-item label="重量到" :label-width="formLabelWidth">
                        <el-input v-model="newPrice.to" placeholder="如 “1.0”"></el-input>
                    </el-form-item>
                    <el-form-item label="计费重量单位" :label-width="formLabelWidth">
                        <el-input v-model="newPrice.unitWeight" placeholder="如 “2.0”"></el-input>
                    </el-form-item>
                    <el-form-item label="费用定义分类" :label-width="formLabelWidth">
                        <el-select name="currency" v-model="newPrice.chargeType" style = "width: 100%;" placeholder = "请选择费用定义分类">
                          <el-option v-for="(chargeType, index) in chargeTypes" :value="chargeType.value" :label="chargeType.name" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="重量段费用" :label-width="formLabelWidth">
                      <el-input type="textarea" :rows="2" v-model="newPrice.price" placeholder="可以是一个数值或者是一个计算公式"></el-input>
                    </el-form-item>
                    <el-form-item label="成本价" :label-width="formLabelWidth">
                        <el-input type="textarea" :rows="2" v-model="newPrice.costPrice" placeholder="如 “19.8”"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" type="warning" @click="createPriceAndContinue">确定并继续添加</el-button>
                    <el-button size="small" @click="dialogFromVisible = false">取消</el-button>
                    <el-button size="small" @click="createPrice">确认</el-button>
                </div>
            </el-dialog>
            <!-- 展示计算公式详情 -->
            <el-dialog title="明细" :visible.sync="dialogShowFormula" append-to-body>
              <p v-if="formulaStr !== ''" v-html="formulaStr"></p>
            </el-dialog>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" type="primary" @click="commitPriceDefinition">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
  props: {
    dialogDefinitionVisible: Boolean,
    initData: {
      type: Object,
      default() {
        return {};
      }
    },
    minBillableWeight: {
      type: String,
      required: true
    },
    weightUnit: {
      type: String,
      required: true
    },
    discount: {
      type: String,
      default: "0"
    },
    currentLayerIndex: {},
    BasicVariables: {
      type: [Array]
    },
    // close: {
    //   type: Function
    // },
    aggregateId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogShowVariables: false,
      dialogShowFormula: false,
      dialogFromVisible: false,
      dialogTableVisible: false,
      isTestPriceFailed: false,
      formLabelWidth: "100px",
      priceDefinition: {
        currency: "CNY",
        effectiveFrom: "",
        effectiveTo: "",
        mainCharge: {
          name: "mainCharge",
          cal: "JS",
          formula: "",
          logisticPrice: {
            minBillableWeight: "",
            selectedAreaCode: "",
            areas: [],
            weightUnit: "",
            prices: {}
          }
        },
        costCharge: {
          name: "costCharge",
          formula: ""
        },
        additionalCharges: [],
        userDefinedVariables: []
      },
      preCheck: true,
      editing: false,
      isEditPrice: false,
      isAreaActive: true,
      isWeightActive: false,
      isBasicActive: true,
      isCustomActive: false,
      isMainActive: false,
      isExtraActive: false,
      isMainCalActive: true,
      isMainShipActive: false,
      isVariableModify: false,
      oldVariable: {},
      isAdditionalChargeModify: false,
      oldAdditionalCharge: {},
      selected: null,
      weightUnits: [
        { name: "KG", value: "KG" },
        { name: "Pounds", value: "POUNDS" },
        { name: "Ounce", value: "OZ" }
      ],
      chargeTypes: [
        { name: "固定费用", value: "CONSTANT" },
        { name: "简单单价（重量*单价）", value: "UNITPRICE" },
        {
          name: "续重单价（除扣前一个重量段剩下的重量 * 单价）",
          value: "CHAINED"
        }
      ],
      currencies: [
        // { name: "美元", value: "USD" },
        // { name: "欧元", value: "EUR" },
        { name: "人民币", value: "CNY" }
        // { name: "港币", value: "HKD" },
        // { name: "日元", value: "JPY" }
      ],
      newArea: {
        areaCode: "",
        regionStr: "",
        regions: []
      },
      newVariable: { name: "", formula: "" },
      newExtra: {
        name: "",
        chargeName:"",
        condition: "",
        formula: ""
      },
      newPrice: {
        areaCode: "",
        from: "",
        to: "",
        unitWeight: "",
        price: "",
        costPrice: "",
        chargeType: "",
        expr: ""
      },
      BasicVariableDatas: [],
      priceTestResult: [],
      file: "",
      formulaStr: ""
    };
  },
  filters: {
    formatTime(val) {
      if (val != "") {
        return (
          new Date(val).getFullYear() +
          "-" +
          ("0" + (new Date(val).getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + new Date(val).getDate()).slice(-2) +
          " " +
          ("0" + new Date(val).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(val).getMinutes()).slice(-2) +
          ":" +
          ("0" + new Date(val).getSeconds()).slice(-2)
        );
      }
    }
  },
  watch: {
    initData: function() {
      if (JSON.stringify(this.initData) !== "{}") {
        this.priceDefinition = this.initData;
      } else {
        this.priceDefinition = {
          currency: "CNY",
          effectiveFrom: "",
          effectiveTo: "",
          mainCharge: {
            name: "mainCharge",
            cal: "JS",
            formula: "",
            logisticPrice: {
              minBillableWeight: "",
              selectedAreaCode: "",
              areas: [],
              weightUnit: "KG",
              prices: {}
            }
          },
          costCharge: {
            name: "costCharge",
            formula: ""
          },
          additionalCharges: [],
          userDefinedVariables: []
        };
      }
    }
  },
  created() {
    this.value1 = "";
    if (JSON.stringify(this.initData) !== "{}") {
      this.priceDefinition = this.initData;
      if(this.priceDefinition.mainCharge.cal === 'JS') {
        this.isMainCalActive = true
        this.isMainShipActive = false
      } else if(this.priceDefinition.mainCharge.cal === 'SHIPMENT'){
        this.isMainCalActive = false
        this.isMainShipActive = true
      }
    } else {
      this.priceDefinition = {
        currency: "CNY",
        effectiveFrom: "",
        effectiveTo: "",
        mainCharge: {
          name: "mainCharge",
          cal: "JS",
          formula: "",
          logisticPrice: {
            minBillableWeight: "",
            selectedAreaCode: "",
            areas: [],
            weightUnit: "",
            prices: {}
          }
        },
        costCharge: {
          name: "costCharge",
          formula: ""
        },
        additionalCharges: [],
        userDefinedVariables: []
      };
    }
  },

  methods: {
    addMainCharge () {
      if(!this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode || this.priceDefinition.mainCharge.logisticPrice.selectedAreaCode === '') {
        this.$message.warning('请先选择分区编号！')
      } else{
        this.dialogFromVisible = true
      }
    },
    // 关闭弹层前清空掉测试模板
    close() {
      this.resetTestPrice();
      this.$emit('getDialogDefinitionVisible', false);
    },
    // 清空测试
    resetTestPrice() {
      this.priceTestResult = [];
      this.$refs.testPriceFile.value = "";
      this.isTestPriceFailed = false;
    },
    // 价格测试返回的结果--展示计算公式
    showFormulaDetails(vars){
      this.dialogShowFormula = true;
      this.formulaStr = vars.replace(/\n/g,'<br>');
    },
    showAllBasicVariables(vars) {
      this.dialogShowVariables = true;
      this.BasicVariableDatas = vars;
    },
    edit() {
      this.editing = true;
      this.$nextTick(function() {
        this.$el.focus();
      });
    },
    updateView(e) {
      //相当于触发生命周期函数 updated 
    this.$forceUpdate()
    } ,
    editPrice() {
      this.isEditPrice = true;
      this.$nextTick(function() {
        this.$el.focus();
      });
    },
    save() {
      for (let area of this.priceDefinition.mainCharge.logisticPrice.areas) {
        area.regionStr = area.regionStr.trim().replace(/，/g, ",");
        area.regions = [area.regionStr];
        //area.regions = area.regionStr.split(",");
        // if (!(area.regions instanceof Array)) {
        //   let regStr = area.regions;
        //   area.regions = regStr.split(",");
        // }
      }
      this.editing = false;
    },
    savePrice(data) {
      data.forEach((item, index) => {
        item.expr = item.chargeType + ":" + item.price
      })
      this.isEditPrice = false;
    },
    selectAreaCode() {
      this.$forceUpdate();
    },
    doPreCheckAndCommit(priceDefinition) {
      let url = '/price/validation';
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$request1({
        method: 'post',
        url: url,
        data: priceDefinition
      })
        .then(response => {
          if (response.data.success) {
            this.doCommmit();
            loading.close();
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    commitPriceDefinition() {
      if (!this.checkData(this.priceDefinition)) {
        return;
      }
      if(this.isTestPriceFailed){
        this.$message.error('您的价格测试有误，请修改后重新提交！');
        return false;
      }

      let _this = this;
      if (_this.priceDefinition.mainCharge.formula && _this.priceDefinition.mainCharge.formula.trim() !== "") {
        _this.priceDefinition.mainCharge.cal = "JS";
      } else {
        _this.priceDefinition.mainCharge.cal = "SHIPMENT";
      }

      if (this.preCheck) {
        let success = true;
        this.doPreCheckAndCommit(this.priceDefinition);
      } else {
        _this.doCommmit();
      }
    },
    doCommmit() {
      this.$confirm("确定要提交价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$message({
          type: "success",
          message: "提交成功！"
        });
        this.isTestPriceFailed = false
        this.isBasicActive = true
        this.isCustomActive = false
        this.isMainActive = false
        this.isExtraActive = false
        this.$emit("callback", this.priceDefinition);
        this.resetTestPrice();
      });
    },
    checkData(data) {
      if (data.currency == "") {
        this.$message.error("请选择币种！");
        return false;
      }
      if (data.effectiveFrom == "" || data.effectiveTo == "") {
        this.$message.error("请补全价格有效期！");
        return false;
      }
      if (data.effectiveFrom > data.effectiveTo) {
        this.$message.error("价格开始日期必须小于结束日期！");
        return false;
      }
      let validAreas = data.mainCharge.logisticPrice.areas
      let validSaleFormula = data.mainCharge.formula
      let validCostFormula = data.costCharge.formula
      if (
        validAreas.length > 0 && 
        ((validSaleFormula && validSaleFormula !=='') || (validCostFormula && validCostFormula !==''))
      ) {
        this.$message({
          showClose: true,
          message: "计算公式和物流价格定义二者只能选其一",
          type: "error"
        });
        return false;
      } 
      else if(
        data.mainCharge.cal === 'JS' && 
        ((validSaleFormula == null || validSaleFormula ==='') || (validCostFormula == null || validCostFormula ==='')) && 
        validAreas.length === 0
      ){
       
        this.$message({
          showClose: true,
          message: "当前选择的是计算公式，成本价和销售价都不能为空",
          type: "error"
        });
        return false;
      } 
      else if(
        data.mainCharge.cal === 'SHIPMENT' && 
        ((validSaleFormula == null || validSaleFormula ==='') || (validCostFormula == null || validCostFormula ==='')) && 
        validAreas.length === 0
      ){
        this.$message({
          showClose: true,
          message: "当前选择的是物流价格定义，请补全对应的分区及重量段费用等信息",
          type: "error"
        });
        return false;
      } 
      else if (
        validAreas.length === 0 &&
        (validSaleFormula === "" || validSaleFormula == null) && 
        (validCostFormula === "" || validCostFormula == null)
      ) {
        this.$message({
          showClose: true,
          message: "计算公式和物流价格定义二者必选其一",
          type: "error"
        });
        return false;
      }

      return true;
    },
    // 添加自定义变量
    addVariable() {
      if (this.isVariableModify) {
        // 修改
        this.oldVariable.name = this.newVariable.name;
        this.oldVariable.formula = this.newVariable.formula;
      } else {
        // 添加
        this.priceDefinition.userDefinedVariables.push(this.newVariable);
      }
      this.isVariableModify = false;
      this.clearNewVariable();
    },
    resetAddVariable() {
      if (this.isVariableModify) {
        this.newVariable.name = this.oldVariable.name;
        this.newVariable.formula = this.oldVariable.formula;
      } else {
        this.clearNewVariable();
      }
    },
    clearNewVariable() {
      this.newVariable = { name: "", formula: "" };
    },
    // 添加附件费用
    addExtra() {
      var reg = /^[a-zA-Z][a-zA-Z0-9_]*$/
      if (this.isAdditionalChargeModify) {
        if(!reg.test(this.newExtra.name)){
          this.$message.error('变量名称只能是英文字母，不能包含中文字符！')
          return false
        }
        if(this.newExtra.name === '' || this.newExtra.chargeName === '' || this.newExtra.formula === '') {
          this.$message.error('请补全附加费用信息！')
          return false
        }
        this.oldAdditionalCharge.name = this.newExtra.name;
        this.oldAdditionalCharge.chargeName = this.newExtra.chargeName;
        this.oldAdditionalCharge.formula = this.newExtra.formula;
        this.oldAdditionalCharge.condition = this.newExtra.condition;
      } else {
        if(!reg.test(this.newExtra.name)){
          this.$message.error('变量名称只能是英文字母，不能包含中文字符！')
          return false
        }
        if(this.newExtra.name === '' || this.newExtra.chargeName === '' || this.newExtra.formula === '') {
          this.$message.error('请补全附加费用信息！')
          return false
        }
        this.priceDefinition.additionalCharges.push(this.newExtra);
      }
      this.isAdditionalChargeModify = false;
      this.clearNewExtra();
    },
    resetAddExtra() {
      if (this.isAdditionalChargeModify) {
        this.newExtra.name = this.oldAdditionalCharge.name;
        this.newExtra.chargeName = this.oldAdditionalCharge.chargeName;
        this.newExtra.formula = this.oldAdditionalCharge.formula;
        this.newExtra.condition = this.oldAdditionalCharge.condition;
      } else {
        this.clearNewExtra();
      }
    },

    clearNewExtra() {
      this.newExtra = { name: "", chargeName: "",  condition: "", formula: "" };
    },
    // 添加国家分区
    createArea() {
      if (this.newArea.regionStr === "") {
        this.newArea.regions = [];
      } else {
        let regStr = this.newArea.regionStr;
        this.newArea.regions = regStr.split(",");
      }
      let newArea = { areaCode: "", regions: [], regionStr: "" };
      newArea.areaCode = this.newArea.areaCode;
      newArea.regionStr = this.newArea.regionStr;
      newArea.regions = this.newArea.regions;
      this.priceDefinition.mainCharge.logisticPrice.areas.push(newArea);
      this.newArea = { areaCode: "", regionStr: "", regions: [] };
      this.dialogTableVisible = false;
    },
    createPriceAndContinue() {
      this._createPrice();
    },

    // 添加重量段及价格
    createPrice() {
      this._createPrice();
      this.dialogFromVisible = false;
    },
    _createPrice() {
      let prices = this.priceDefinition.mainCharge.logisticPrice.prices;
      let selectedCode = this.priceDefinition.mainCharge.logisticPrice
        .selectedAreaCode;
      this.newPrice.expr = this.newPrice.chargeType + ":" + this.newPrice.price;
      if (prices[selectedCode] !== null && prices[selectedCode] !== undefined) {
        prices[selectedCode].push(this.newPrice);
      } else {
        prices[selectedCode] = [this.newPrice];
      }
      this.clearNewPrice();
    },
    clearNewPrice() {
      this.newPrice = {
        areaCode: "",
        from: "",
        to: "",
        unitWeight: "",
        price: "",
        costPrice: "",
        chargeType: "",
        expr: ""
      };
    },
    // 国家分区---删除一行
    deleteArea(index) {
      delete this.priceDefinition.mainCharge.logisticPrice.prices[
        this.priceDefinition.mainCharge.logisticPrice.areas[index].areaCode
      ];
      this.priceDefinition.mainCharge.logisticPrice.areas.splice(index, 1);
    },
    // 重量段及价格---删除一行
    deletePrice(index) {
      let selectedCode = this.priceDefinition.mainCharge.logisticPrice
        .selectedAreaCode;
      let prices = this.priceDefinition.mainCharge.logisticPrice.prices;
      prices[selectedCode].splice(index, 1);
      this.$forceUpdate();
    },
    // 自定义变量---删除一条
    deleteVariable(index) {
      this.priceDefinition.userDefinedVariables.splice(index, 1);
    },
    // 附加费用---删除一条
    deleteExtra(index) {
      this.priceDefinition.additionalCharges.splice(index, 1);
    },
    // 选项卡切换
    toggleActiveTab(tabName, data) {
      this.isCustomActive = false;
      this.isMainActive = false;
      this.isExtraActive = false;
      this.isBasicActive = false;

      // 左侧类目选项卡切换
      if (tabName === "custom") {
        if (data != "") {
          // 点击变量回写
          this.oldVariable = data;
          this.newVariable.name = data.name;
          this.newVariable.formula = data.formula;
          this.isVariableModify = true;
        } else {
          // 切换菜单
          this.isVariableModify = false;
          this.clearNewVariable();
        }
        this.isCustomActive = true;
        return;
      } else if (tabName === "main") {
        if (
          this.priceDefinition.mainCharge.formula !== "" && this.priceDefinition.mainCharge.formula !== null &&
          this.priceDefinition.costCharge.formula !== "" && this.priceDefinition.costCharge.formula !== null
        ) {
          this.isMainActive = true;
          this.isMainCalActive = true;
          this.isMainShipActive = false;
        } else {
          this.isMainActive = true;
          this.isMainCalActive = false;
          this.isMainShipActive = true;
        }
        return;
      } else if (tabName === "additionalCharge") {
        if (data != "") {
          this.oldAdditionalCharge = data;
          this.newExtra.name = data.name;
          this.newExtra.chargeName = data.chargeName;
          this.newExtra.formula = data.formula;
          this.newExtra.condition = data.condition;
          this.isAdditionalChargeModify = true;
        } else {
          this.isAdditionalChargeModify = false;
          this.clearNewExtra();
        }
        this.isExtraActive = true;
        return;
      } else if (tabName === "basic") {
        this.isBasicActive = true;
        return;
      }
      // 主费用选项卡 计算公式+物流计算公式
      if (tabName === "MainCal") {
        this.priceDefinition.mainCharge.cal = "JS";
        this.isMainActive = true;
        this.isMainCalActive = true;
        this.isMainShipActive = false;
        return;
      } else if (tabName === "MainShip") {
        this.priceDefinition.mainCharge.cal = "SHIPMENT";
        this.isMainActive = true;
        this.isMainCalActive = false;
        this.isMainShipActive = true;
        return;
      }
      this.isAreaActive = false;
      this.isWeightActive = false;
      // 主费用物流计算公式选项卡切换 分区国家+重量段及费用
      if (tabName === "area") {
        this.isMainActive = true;
        this.isAreaActive = true;
      } else if (tabName == "unitWeight") {
        this.isMainActive = true;
        this.isAreaActive = false;
        this.isWeightActive = true;
      }
    },
    getFile(event) {
      this.file = event.target.files[0];
    },
    resetPriceForm () {
      if (this.$refs.parseForm.value !== '') {
        this.$refs.parseForm.value = ''
        this.priceDefinition.mainCharge.logisticPrice.areas = []
      }
    },
    // 上传
    parsePriceDefinitionExcel(event) {
      event.preventDefault();
      if (
        this.priceDefinition.mainCharge.formula && this.priceDefinition.mainCharge.formula.trim() !== "" ||
        this.priceDefinition.costCharge.formula && this.priceDefinition.costCharge.formula.trim() !== ""
      ) {
        this.priceDefinition.mainCharge.cal = "JS";
      } else {
        this.priceDefinition.mainCharge.cal = "SHIPMENT";
      }
      let formData = new FormData();
      this.priceDefinition.mainCharge.logisticPrice.weightUnit = this.weightUnit;
      this.priceDefinition.mainCharge.logisticPrice.minBillableWeight = this.minBillableWeight;
      formData.append("priceDefinition", JSON.stringify(this.priceDefinition));
      formData.append("priceDefinitionFile", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.$request1({
        method: 'POST',
        url: '/price/excel/upload',
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      }).then(response => {
        if(response.data.success === false) {
          this.$notify.error({
            title: '错误',
            message: '您上传的价格模板解析失败，请您仔细检查模板内容或手动输入价格！'
          })
          return
        }
        if(response.data.additionalCharges && response.data.additionalCharges.length > 0){
          this.priceDefinition.additionalCharges = response.data.additionalCharges
        }
        if(response.data.userDefinedVariables && response.data.userDefinedVariables.length > 0){
          this.priceDefinition.userDefinedVariables = response.data.userDefinedVariables
        }
        // TODO：调试的时候注意查看这里
        this.priceDefinition.mainCharge = response.data.mainCharge
       
        let areas = this.priceDefinition.mainCharge.logisticPrice.areas;
        for (let i = 0; i < areas.length; i++) {
          let regionStr = areas[i].regions.join();
          let obj = { regionStr: regionStr };
          areas[i]["regionStr"] = regionStr;
        }
      });
    },
    // 导出
    exportPriceDefinitionExcel() {
      let url = '/price/excel/' + this.aggregateId + '/' + this.priceDefinition.id + '';
      window.location.href = url;
    },
    // 关闭添加分区弹出
    closeNewArea() {
      this.dialogTableVisible = false;
      this.newArea.areaCode = "";
      this.newArea.regionStr = "";
      this.newArea.regions = [];
    },
    // 上传模板测试价格
    uploadAndCheckPrice() {
      let files = this.$refs.testPriceFile.files;
      if (!files || files.length === 0) {
        this.$message.warning("您还没有上传需要测试的模板！");
        return;
      }
      if (
        this.priceDefinition.mainCharge.formula && this.priceDefinition.mainCharge.formula.trim() !== "" &&
        this.priceDefinition.costCharge.formula && this.priceDefinition.costCharge.formula.trim() !== ""
      ) {
        this.priceDefinition.mainCharge.cal = "JS";
      } else {
        this.priceDefinition.mainCharge.cal = "SHIPMENT";
      }
      let formData = new FormData();
      this.priceDefinition.mainCharge.logisticPrice.weightUnit = this.weightUnit;
      this.priceDefinition.mainCharge.logisticPrice.minBillableWeight = this.minBillableWeight;
      formData.append("priceDefinition", JSON.stringify(this.priceDefinition));
      formData.append("testPriceFile", files[0]);
      formData.append("discount", this.discount);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.$request1({
        method: 'POST',
        url: '/price/excel/uploadAndCheckPrice',
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      }).then(response => {
        if(response.data && response.data.length > 0){
          this.priceTestResult = response.data;
          this.isTestPriceFailed = false;
        }else{
          this.$message.error(response.data.message);
          this.isTestPriceFailed = true;
          return false;
        }
      }).catch(error => {
        console.log(error);
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.download-icon {
   color: #5aabff;
   &:hover {
     text-decoration: underline;
   }
}
.upload-icon{
  position:relative; 
  display:inline-block; 
  height:40px;
  overflow:hidden;
  vertical-align:top; 
  cursor:pointer;
  .upload-url{
    box-sizing: border-box; 
    border-radius:2px;
    border: solid 1px #ddd; 
    width: 200px; 
    height:40px;
    line-height: 40px;
    text-indent:3px;
  }
  .upload-input-file{
    position:absolute; 
    right:0; 
    top:0; 
    width: 0;
    height: 0;
    font-size:0; 
    opacity:0; 
    filter:alpha(opacity=0);
    cursor:pointer;
  }
  .upload-btn{
    outline:none;
    // border:0; 
    // padding:7px 10px;
    // color:#fff;
    // background:#1c84c6;
    // cursor:pointer; 
    // margin:3px; 
    // border-radius:3px;
  }
}
.price-form{
  position: relative;
  display: inline-block; 
  margin:0 0 0 15px;
  .clear-icon{
    position: absolute;
    top: 10px;
    right: 5px;
    display: none;
    cursor: pointer;
  }
  &:hover .clear-icon{
    display: block;
  }
  .parse-input{
    display: inline-block; 
    margin-left: 10px;
    padding: 5px;
    padding-right: 30px;
    width: 350px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
}
.download{
  color: #409EFF; 
  &:hover{
    opacity: 0.8;
  }
}
.price-row {
  // 左侧类目
  .left-wrapper {
    &.list-group {
      margin: 0;
      padding: 1px;
      .list-group-item {
        color: #333;
        border-radius: 0;
        &.active {
          background-color: #fff;
          .btn {
            background-color: #409eff;
            color: #fff;
          }
        }
      }
      > .list-group-item {
        margin: -1px 0 10px 0;
        padding: 0;
        border: 0;
        width: 100%;
        .sub-left-wrapper .list-group .list-group-item {
          color: #333;
        }
        .list-content {
          display: block;
          width: 100%;
          margin-bottom: 0;
          background-color: #fff;
          border: 1px solid #ddd;
          text-align: center;
          font-weight: bold;
          color: #333;
          &:hover,
          &:active,
          &:focus {
            color: #fff;
            background-color: #409eff;
          }
          .glyphicon-plus-sign {
            display: inline-block;
            float: right;
            padding-right: 10px;
            color: #ccc;
            &:hover {
              cursor: pointer;
              color: #fff;
            }
          }
        }
        .sub-left-wrapper {
          .list-group {
            margin: 0;
            padding-top: 10px;
            .list-group-item {
              border: none;
              color: #333;
              width: 100%;
              .sub-list-item:hover,
              .sub-list-item:link,
              .sub-list-item:visited {
                text-decoration: none;
              }
              .delete-icon {
                float: right;
                font-weight: 200;
              }
              label {
                font-weight: normal;
              }
              &.valid-item {
                .valid-time {
                  float: left;
                  span {
                    display: block;
                    b {
                      display: inline-block;
                      margin-left: 5px;
                      margin-right: 5px;
                      font-weight: normal;
                    }
                  }
                }
              }
            }
          }
        }
        &.active {
          .list-content {
            background-color: #409eff;
            border-color: #409eff;
            color: #fff;
            border-radius: 4px;
          }
        }
      }
    }
  }
  // 中间区域
  .middle-wrapper {
    // 主费用
    .nav-pills > li {
      float: left;
      display: block;
      + li {
        margin-left: 6px;
      }
    }
    .nav {
      padding: 10px;
      li a {
        padding: 5px 10px;
        color: #333;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
      }
      li.active a {
        background: #409eff;
        color: #fff;
        border-color: #409eff;
        border-radius: 4px;
      }
    }
  }
  .remark-content {
    .list-group-item {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .name {
      margin-right: 15px;
      color: #606266;
    }
    .desc {
      color: #646464;
      font-size: 12px;
    }
  }
}
.upload-test {
  margin-top: 20px;
  .upload-test__title {
    font-size: 14px;
    font-weight: 600;
  }
  .upload-test__form {
    .el-form-item {
      margin-bottom: 0;
      &:last-child {
        margin-top: 15px;
      }
    }
  }
}
.trace-item{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.remarks{
  margin-top: 30px;
  padding-left: 35px;
  b{
    margin-right: 15px;
  }
}
.el-button__export{
  padding: 11px 15px;
  border-radius: 5px;
}
.area-table{
  position: relative;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  font-size: 14px;
  color: #606266;
  tr,
  th {
    background-color: #fff;
  }
  td,
  th {
    padding: 12px;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    border: 1px solid #ebeef5;
  }
  th {
    white-space: nowrap;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/system/definition.vue